<template>
  <table>
    <tbody>
      <tr v-for="(extra, index) of extras" :key="index">
        <td>
          {{ extra.name }}
          <extra-description
            :extra-description="extra.description"
            :extra-terms="extra.terms"
          />
        </td>
        <td class="right">
          <pu-price :price="extra.price" :display-original-price="true" />
          <span class="per-stay">{{ extra.pricingDisplay }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { Component, Prop, toNative, Vue } from '~/utility/pu-class-decorator'
import { ChargeTypeExtra } from '../../../../campsite-details/types'

@Component
class PitchtypesCompulsoryExtras extends Vue {
  @Prop()
  extras: ChargeTypeExtra[]
}

export default toNative(PitchtypesCompulsoryExtras)
</script>
<style scoped>
table tr td:last-of-type {
  text-align: right;
}
</style>
